import ProblemDetailsException from "@rmp/core/exceptions/problemDetailsException";

export default class BadRequestException extends ProblemDetailsException {
}
